import "./carouselZoom.css";
import { useEffect, useRef } from "react";

const CarouselZoom = () => {
     
    const contImgHome = useRef <HTMLDivElement | null> (null);                       /*Efecto zoom de imagenes en portada de Home. Trabaja junto con CSS: .contImgHome .imgHome @keyframes zoomHome */
    useEffect(() => {
        if (!contImgHome.current) return;
              
        const imgs = contImgHome.current.querySelectorAll(".imgHome");
        let i = 0;
        imgs[i].classList.add("zoomOut");
                
        const carousel = () => {
            if (i === imgs.length) i = 0;
            if (!i) {
                imgs[imgs.length - 1].classList.add("zoomOut");
            } else {
                imgs[i - 1].classList.add("zoomOut");
            }
            imgs[i].classList.remove("zoomIn", "zoomOut");          //Los métodos de modificación de clases son asincrónicos, por eso el setTimeout
            setTimeout(() => {
                imgs[i].classList.add("zoomIn");
                i = i + 1;
            }, 100);
            
            setTimeout(() => {
                carousel();
            }, 14000);
        };
        carousel();
    
    }, []);

    return (
        <div className='contImgHome flex' ref={contImgHome}>
            <img src="/images/carousel/2.jpg" alt="Carousel" className='imgHome' />
            <img src="/images/carousel/4.jpg" alt="Carousel" className='imgHome' />
            <img src="/images/carousel/1.jpg" alt="Carousel" className='imgHome' />
            <img src="/images/carousel/3.jpg" alt="Carousel" className='imgHome' />
            <div className="carouselTextCont flex column">
                <h1 className="carouselText1 carouselTextanimation">ITERPROS</h1>
                <h2 className="carouselText2 carouselTextanimation">INGENIERIA EXITOSA</h2>
            </div>
        </div>
    );
};

export default CarouselZoom;
